import { t } from 'i18next';
import { z } from 'zod';

export const NotificationCreateFormSchema = z
	.object({
		title: z.string({ message: t('elements.form.title.errorMin')}),
		message: z.string({ message: t('elements.form.message.error')}),
		isRequired: z.boolean(),
		hotels: z.array(
			z.object({
				hotelId: z.string(),
  			allApartments: z.boolean(),
  			apartmentIds: z.array(
					z.object({
						id: z.string(),
						name: z.string().optional(),
					})
				).optional()
			})
		).min(1, { message: t('elements.form.hotels.error') })
	});

export type NotificationCreateFormData = z.infer<typeof NotificationCreateFormSchema>;